import clsx from 'clsx';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import style from './Button.module.scss';
export function HeaderPrimaryButton({ buttonClassName, outlined, children, href, disableArrow, }) {
    return (React.createElement("button", { type: "button", className: clsx(style.menuButton, { [style.arrow]: !disableArrow }, { [style.primary]: !outlined }, { [style.outline]: outlined }, buttonClassName), onClick: href ? () => window.open(href) : undefined },
        children,
        !disableArrow && React.createElement(FontAwesomeIcon, { className: style.buttonIcon, icon: faChevronRight })));
}
